/**
 * Build-time feature flags.
 *
 * CRA inlines REACT_APP_* values into the bundle at build time, so a static SPA
 * has no runtime toggle: flipping a flag means changing the env var for that
 * environment (azure-pipelines.yml / .env.<env>) and redeploying.
 */

/**
 * Client-facing "Profils de talents" (anonymized matched talents) page.
 * Enabled by default; set REACT_APP_CLIENT_TALENTS_ENABLED=false to hide its
 * route, its menu entry and the default landing redirect. Currently off in
 * production (kept on in recette for testing).
 */
export const CLIENT_TALENTS_ENABLED =
	process.env.REACT_APP_CLIENT_TALENTS_ENABLED !== "false";
